<a
	class="card-block copo-clickable"
	mat-ripple
	[routerLink]="['/order-tracking/schedule-business-order/card', sbOrder.supplierOrderNumber]">
	<div class="order-tracking-list-card-header">
		<span class="order-tracking-list-card-header-title">{{ sbOrder.customerOrderNumber }}</span>
		<span class="order-tracking-list-card-header-ton">{{ getBusinessStatus(sbOrder) }}</span>
	</div>
	<div class="order-tracking-list-card-informations-block">
		<div class="order-tracking-list-card-information-block">
			<span class="order-card-label" translate>{{ getProductLabel() }}</span>
			<span class="order-card-value">{{ getProductName(sbOrder) }}</span>
		</div>
		<div class="order-tracking-list-card-information-block">
			<span class="order-card-label" translate>schedule-business-order-filter.customer-article-reference</span>
			<span class="order-card-value">{{ sbOrder | copoModelInfo:'customerArticleReference' }}</span>
		</div>
	</div>
</a>
